import Api, { params } from '../modules/Api.js';

import { IS_LOADING, ISNT_LOADING } from './isLoading';
import { SET_ERROR, RESET_ERROR } from './error';

export const GET_COUNTRIES_REQUESTED = 'countries/GET_COUNTRIES_REQUESTED';
export const GET_COUNTRIES_SUCCESSFUL = 'countries/GET_COUNTRIES_SUCCESSFUL';
export const GET_COUNTRIES_FAILED = 'countries/GET_COUNTRIES_FAILED';

export const GET_ALL_COUNTRIES_REQUESTED = 'countries/GET_ALL_COUNTRIES_REQUESTED';
export const GET_ALL_COUNTRIES_SUCCESSFUL = 'countries/GET_ALL_COUNTRIES_SUCCESSFUL';
export const GET_ALL_COUNTRIES_FAILED = 'countries/GET_ALL_COUNTRIES_FAILED';

const initialState = [];

export default function Countries(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_COUNTRIES_SUCCESSFUL:
      return action.allcountries;
    case GET_COUNTRIES_SUCCESSFUL:
      return action.countries;
    case GET_ALL_COUNTRIES_FAILED:
    case GET_COUNTRIES_FAILED:
      return initialState;
    case GET_ALL_COUNTRIES_REQUESTED:
    case GET_COUNTRIES_REQUESTED:
      return initialState;
    default:
      return state;
  }
}

export const getCountries = () => async (dispatch) => {
  dispatch({ type: RESET_ERROR });
  dispatch({ type: IS_LOADING });
  dispatch({ type: GET_COUNTRIES_REQUESTED });

  return Api('/country/actives', { params: params })
    .then(res => {
      dispatch({
        type: GET_COUNTRIES_SUCCESSFUL,
        countries: res.data
      });
      dispatch({ type: ISNT_LOADING });
    })
    .catch(err => {
      dispatch({ type: GET_COUNTRIES_FAILED });
      if(err.response.status !== 401){
        dispatch({
          type: SET_ERROR,
          value: err
        });
      }
      dispatch({ type: ISNT_LOADING });
    });
};

export const getAllCountries = () =>
  dispatch => {
    dispatch({ type: RESET_ERROR });
    dispatch({ type: IS_LOADING });
    dispatch({ type: GET_ALL_COUNTRIES_REQUESTED });

    return Api('/country', { params: params })
      .then(res => {
        dispatch({
          type: GET_ALL_COUNTRIES_SUCCESSFUL,
          allcountries: res.data
        });
        dispatch({ type: ISNT_LOADING });
      })
      .catch(err => {
        dispatch({ type: GET_ALL_COUNTRIES_FAILED });
        if(err.response.status !== 401){
          dispatch({
            type: SET_ERROR,
            value: err
          });
        }
        dispatch({ type: ISNT_LOADING });
      });
  };
